import { formatNumber } from 'ui';

export const convertFeatureToNumber = (feature: number | undefined): number => {
  if (typeof feature === 'undefined') {
    return 0;
  }

  return feature;
};

export const formatPercentageFeature = (feature: number) => {
  return formatNumber(convertFeatureToNumber(feature) * 100, { minimumFractionDigits: 1, style: 'percent' });
};

export const isZeroOrSmallForDisplay = (feature: number | null) => {
  return formatPercentageFeature(feature ?? 0) === '0.0%';
};

export const formatPercentageFeatureAsRange = (feature: number): string => {
  const val = convertFeatureToNumber(feature) * 100;
  if (val === 0) return 'None Detected';
  if (val < 10) return 'Detected';

  const range = 10;
  let lowerBound = Math.floor(val / range) * range;
  let upperBound = lowerBound + range;

  if (lowerBound < 0) lowerBound = 0;
  if (upperBound > 100) upperBound = 100;

  return `${lowerBound}-${upperBound}%`;
};

export const formatWeightFeature = (weightNumber: number, totalWeight: number) => {
  let weight = formatNumber(weightNumber, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'kilogram',
  });

  if (weight === '0.00kg' && weightNumber !== 0) {
    weight = '<0.01kg';
  }

  const percentage = formatPercentageFeature(weightNumber / totalWeight);

  return {
    percentage,
    weight,
  };
};
